import { render, staticRenderFns } from "./LancamentoDeFrequenciaTurmaPage.vue?vue&type=template&id=5ebb9a44&scoped=true"
import script from "./LancamentoDeFrequenciaTurmaPage.vue?vue&type=script&lang=js"
export * from "./LancamentoDeFrequenciaTurmaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebb9a44",
  null
  
)

export default component.exports